import env from 'env'

import { StringOrNull } from '../../constants'
import { Api } from '.'
import { SUBSCRIPTION_STATUS } from '../../constants/enums'

type SubscriptionServiceLevel = {
  name: string,
  isVideoAvailable: boolean,
}

class SubscriptionApi extends Api {
  origin = env.SUBSCRIPTION_API_BASE
  version = 'v1'

  async fetchSubscription() {
    try {
      const response = await this.fetch('/me/subscriptions')
      if (response.ok) return await response.json() as SubscriptionResponse
      return null
    } catch {
      return null
    }
  }

  async fetchLevels() {
    try {
      const response = await this.fetch('/subscriptions/service-levels')
      if (response.ok) return await response.json() as SubscriptionServiceLevel[]
      return []
    } catch {
      return []
    }
  }
}

class AccountApi extends Api {
  origin = env.OIDC_AUTHORITY
  version = 'v1'

  async fetchProfile(): Promise<AccountResponse | null> {
    try {
      const response = await this.fetch('/user/info')
      if (response.ok) return await response.json()
      return null
    } catch {
      return null
    }
  }
}

interface SubscriptionStripePlanResponse {
  id: string
  price: number
  period: number
  planId: string
  description: string
  serviceLevel: string
  trialPeriodDays: number | null
}

interface SubscriptionStripePromoPlanResponse {
  plan: SubscriptionStripePlanResponse
  promoCode: string
  promoEndsAt: string
  promoPrice: number
  promoStartsAt: string
  description: string
}

interface SubscriptionResponse {
  id: StringOrNull
  allowAddNewSubscription: boolean
  isTrialAvailable: boolean
  isContentAccessible: boolean
  startedAt: StringOrNull
  endsAt: StringOrNull
  plan: SubscriptionStripePlanResponse | null
  promo: SubscriptionStripePromoPlanResponse | null
  status: SUBSCRIPTION_STATUS | null
  gateway: StringOrNull
  legacySubscriptionId: StringOrNull
  stripeMetaData: Record<string, string> | null
}

interface AccountResponse {
  id: StringOrNull
  firstName: StringOrNull
  lastName: StringOrNull
  email: StringOrNull
  isActive: boolean
}

export {
  AccountApi,
  SubscriptionApi
}

export type {
  SubscriptionResponse,
  SubscriptionStripePlanResponse,
  SubscriptionStripePromoPlanResponse,
  SubscriptionServiceLevel,
  AccountResponse,
}
